"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PivotEffluentSpreader = void 0;
const helpers_1 = require("@turf/helpers");
const turf_1 = require("@turf/turf");
const index_1 = require("../../DefinitionAndHelpers/index");
const EffluentTracker_1 = require("./EffluentTracker");
const typeName = 'PivotEffluentSpreader';
const DEFAULT_THROW_RADIUS = 0;
const dev = process.env.REACT_APP_DEBUG;
const debug = dev && false;
class PivotEffluentSpreader extends EffluentTracker_1.EffluentTracker {
    // extends DeviceEnabledType<SupportedDevices> {
    constructor(ob) {
        var _a;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
    }
    /**
     * Updated relevant runs. Allows runs of type PivotEffluentSpreader
     * @param runList
     * @returns runs of correct run type
     */
    getRelevantRuns(runList) {
        debug && console.log('Using pivot specific - getRelevantRuns');
        // return only travelling type
        let filteredRuns = runList.filter((run) => run.pathType === index_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader);
        return filteredRuns;
    }
    /**
     * Given active path data, convert it into datapoints on the mapped run
     * - Should be used for Travelling and Lateral
     * @param run
     * @param path
     * @returns
     */
    getPathOnRun(path, run) {
        var _a, _b;
        debug && console.log('Using default - getPathOnRun');
        if (run === undefined || this.throwDistance === null) {
            return super.getPathOnRun(path);
        }
        // || condition for pivot which doesn't know the radius from the center
        return index_1.EffluentSpreaderHelper.mapCirclePoints(path, run.path[0], (_a = run.radius) !== null && _a !== void 0 ? _a : this.radius, (_b = run.throwDistance) !== null && _b !== void 0 ? _b : this.throwDistance);
    }
    /**
     * Should be for pivot only
     * Function to get the closest path of a run, given a set of runs
     * @param runs
     * @param rawPath
     * @returns the path closests to the path of the spreader
     */
    getBestMatchedRun(runs, rawPath = this.path) {
        debug && console.log('Using default - getBestMatchedRun');
        const parsedPath = rawPath !== null && rawPath !== void 0 ? rawPath : this.path;
        // check there are runs to check against
        // check the path is of length
        if (runs.length === 0 || parsedPath === null || parsedPath.length === 0) {
            return undefined;
        }
        //turf current path
        const currentPathTurf = index_1.EffluentSpreaderHelper.convertPositionToTurf(parsedPath).map((tf) => (0, helpers_1.point)(tf));
        let runScore = runs
            .map((run) => {
            let runPoint = run.path;
            let turfedRun;
            if (run.pathType === index_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader && (runPoint === null || runPoint === void 0 ? void 0 : runPoint.length) === 1) {
                // construct line
                let potentialPoints = (0, turf_1.circle)(index_1.EffluentSpreaderHelper.convertPositionToTurf(runPoint)[0], run.radius, { units: 'meters' }).geometry.coordinates[0];
                turfedRun = (0, helpers_1.lineString)(potentialPoints);
            }
            else {
                debug && console.log('FAILED. Path needs to be of type PivotEffluentSpreader');
                return undefined;
            }
            let distance = currentPathTurf.reduce((acc, cur) => {
                let dis = (0, turf_1.pointToLineDistance)(cur, turfedRun, { units: 'meters' });
                acc += dis;
                return acc;
            }, 0);
            return {
                distance,
                average: distance / (parsedPath.length || 1),
                run,
            };
        })
            .filter((val) => val !== undefined)
            .sort((a, b) => a.distance - b.distance);
        return runScore[0];
    }
    /**
     * Pivot Override
     * Function to get the spread LatLngs, and area (m^2), of the raw run
     * @returns LatLngs and area (m^2) obj
     */
    getSpreadOfRawRun(relevantRun, rawPath = this.mappedPath) {
        var _a;
        const parsedPath = (_a = rawPath !== null && rawPath !== void 0 ? rawPath : this.mappedPath) !== null && _a !== void 0 ? _a : this.path;
        debug && console.log(' PLZ', relevantRun);
        debug && console.log(' parsedPath', parsedPath);
        let positions = undefined;
        if (parsedPath && parsedPath.length > 0) {
            if (relevantRun) {
                // if (relevantRun.path.length === 1) {
                //   positions = EffluentSpreaderHelper.mapCircleRun(
                //     parsedPath,
                //     relevantRun.path[0],
                //     relevantRun.throwDistance + relevantRun.radius,
                //     relevantRun.coverage,
                //     relevantRun.throwDistance,
                //   )
                //   console.log(' positions', positions)
                // } else if (relevantRun.path.length > 1) {
                //   console.log(' PLZZZZ')
                positions = (0, index_1.convertLineTypePathToArea)(parsedPath, relevantRun.throwDistance);
                // }
                if (positions) {
                    let turfBoundary = index_1.EffluentSpreaderHelper.convertPositionToTurf(positions);
                    let turfArea = index_1.EffluentSpreaderHelper.createArea([turfBoundary]);
                    let area = index_1.EffluentSpreaderHelper.getAreaMeter(turfArea);
                    return { positions, area };
                }
            }
            return super.getSpreadOfRawRun(relevantRun, parsedPath);
        }
        return undefined;
    }
    // /**
    //  * Pivot - getSpreadOfMappedRun
    //  *
    //  * Should be ok to delete, as it esentially follows the base logic
    //  * @param relevantRun
    //  * @param rawPath
    //  * @returns
    //  */
    getSpreadOfMappedRun(relevantRun, rawPath = this.mappedPath) {
        var _a, _b;
        debug && console.log('Using pivot specific - getSpreadOfMappedRun');
        debug && console.log(' rawPath', rawPath);
        debug && console.log(' this.mappedPath', this.mappedPath);
        debug && console.log(' this.path', this.path);
        let mappedPoints = (_a = rawPath !== null && rawPath !== void 0 ? rawPath : this.mappedPath) !== null && _a !== void 0 ? _a : this.path;
        debug && console.log(' mappedPoints', mappedPoints);
        debug && console.log(' relevantRun', relevantRun);
        // let mappedPoints = parsedPath
        if (mappedPoints && mappedPoints.length > 1) {
            debug && console.log(' mappedPoints many');
            if (relevantRun) {
                debug && console.log(' has relevant');
                const coverageArea = index_1.EffluentSpreaderHelper.mapCircleRun(mappedPoints, relevantRun.path[0], relevantRun.radius, relevantRun.coverage, (_b = this.throwDistance) !== null && _b !== void 0 ? _b : relevantRun.throwDistance);
                let area = index_1.EffluentSpreaderHelper.getAreaMeter(index_1.EffluentSpreaderHelper.createArea([index_1.EffluentSpreaderHelper.convertPositionToTurf(coverageArea)]));
                return { positions: coverageArea, area };
            }
        }
        return this.getSpreadOfRawRun(relevantRun, mappedPoints);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            singleDeviceControl: {
                type: 'Boolean',
                editable: true,
                default: false,
                label: 'Single Device Control',
                required: true,
            },
            span: {
                type: 'Number',
                editable: true,
                label: 'Pivot Span Length (m)',
                name: 'Pivot Span Length (m)',
                description: 'Pivot Span Length (m)',
                required: true,
            },
            location_lat: {
                type: 'Number',
                precision: 5,
                editable: false,
                label: 'Pivot Lat',
                limits: {
                    min: -90,
                    max: 90,
                },
                required: false,
            },
            location_lng: {
                type: 'Number',
                precision: 5,
                editable: false,
                label: 'Pivot Lng',
                limits: {
                    min: -180,
                    max: 180,
                },
                required: false,
            },
        };
    }
}
exports.PivotEffluentSpreader = PivotEffluentSpreader;
